import React from 'react';

import Accordion from 'components/Accordion';
import Checkbox from 'components/DesignSystem/Checkbox';
import Snackbar from 'components/DesignSystem/Snackbar';
import useModels from 'hooks/Meteorology/Fields/TrackingForecast/DetailedView/useModel';

export default function MultiModel() {
  const {
    models, toggleMultiModel, isModelSelected,
  } = useModels();

  return (
    <Accordion.Item eventKey="multimodel" id="multimodel-accordion">
      <Accordion.Header>Modelos</Accordion.Header>
      <Accordion.Body>
        {models.length === 0 && (
          <Snackbar>Nenhum modelo disponível para a frequência temporal selecionada.</Snackbar>
        )}
        {models.map((model) => (
          <Checkbox
            key={model.id}
            label={model.label}
            checked={isModelSelected(model.value)}
            onChange={() => toggleMultiModel(model.value)}
            className="my-2"
          />
        ))}
      </Accordion.Body>
    </Accordion.Item>
  );
}
